<template>
  <div :class="['px-3 py-2 pl-10 leading-6 border text-gray-600', borderColor, {'text-justify': langOptions.text_justify}]">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" :class="['absolute w-6 h-6 -ml-8', iconColor]">
      <path v-if="type === 'tip'" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11v6h2v-6h-2zm0-4v2h2V7h-2z" />
      <path v-if="type === 'question'" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm2-1.645A3.502 3.502 0 0 0 12 6.5a3.501 3.501 0 0 0-3.433 2.813l1.962.393A1.5 1.5 0 1 1 12 11.5a1 1 0 0 0-1 1V14h2v-.645z" />
      <path v-if="type === 'warning'" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm0-8v6h2V7h-2z" />
      <path v-if="type === 'error'" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z" />
    </svg>
    <h6 v-if="title" :class="['mb-1 font-medium', titleColor]">{{ title }}</h6>
    <slot>
      <p v-html="content" />
    </slot>
  </div>
</template>

<script>
  import {computed} from '@vue/composition-api'

  import useI18n from '@/composables/i18n'

  export default {
    name: 'HintBox',

    props: {
      type: {
        type: String,
        required: true,
      },

      title: {
        type: String,
        default: null,
      },

      content: {
        type: String,
        default: null,
      },
    },

    setup (props) {
      const borderColor = computed(() => ({
        tip: 'border-gray-300',
        question: 'border-gray-300',
        warning: 'border-yellow-400',
        error: 'border-red-500',
      }[props.type]))

      const iconColor = computed(() => ({
        tip: 'fill-gray-500',
        question: 'fill-gray-500',
        warning: 'fill-yellow-400',
        error: 'fill-red-500',
      }[props.type]))

      const titleColor = computed(() => ({
        tip: 'text-black',
        question: 'text-black',
        warning: 'text-yellow-600',
        error: 'text-red-700',
      }[props.type]))

      const {langOptions} = useI18n()

      return {
        borderColor,
        iconColor,
        titleColor,

        langOptions,
      }
    },
  }
</script>
